// Google's place photos (lh3.googleusercontent.com links from OpenWeb Ninja, HasData, …) come at the size the
// link asks for. The searches return a 512 px thumbnail ("photo_url"), which the app stored as both the
// thumbnail (Photo) and the main photo (Photo_m), so a guide built with Search looked soft (user, 2026-11-04).
// The link takes a size: "…=w1600-h1200-k-no". Photo = the thumbnail, Photo_m = the main photo.
// Other links (Wikimedia, our own /Images, Google Drive's lh3…/d/ links) are left as they are.
export const THUMB = { w: 512, h: 384 };
export const MAIN = { w: 1600, h: 1200 };

const isGooglePhoto = (url) => /^https:\/\/lh\d\.googleusercontent\.com\//.test(url || "") && !/^https:\/\/lh\d\.googleusercontent\.com\/d\//.test(url);

export function googlePhotoAt(url, size) {
  if (!isGooglePhoto(url)) return url;
  // A street-view panorama link carries its view in the size part (…-ya…-ro…): leave it alone.
  if (/=[^/]*-ya[\d.]+-ro/.test(url)) return url;
  return url.replace(/=[^/=]*$/, "") + `=w${size.w}-h${size.h}-k-no`;
}

// { Photo, Photo_m } for a place.
export const googlePhotoFields = (url) => ({ Photo: googlePhotoAt(url, THUMB), Photo_m: googlePhotoAt(url, MAIN) });

// { url, url_m } for the image lists (ImageDialog, processImages).
export const googlePhotoItem = (url) => ({ url: googlePhotoAt(url, THUMB), url_m: googlePhotoAt(url, MAIN) });
